import { atom } from 'recoil'

export const updateState = atom({
    key: 'updateState',
    default: 0,
});